export default __webpack_public_path__ + "static/media/Free Courses to learn JavaScript.b705d60b.jpg";